/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActivityItem } from './ActivityItem';
import {
    ActivityItemFromJSON,
    ActivityItemFromJSONTyped,
    ActivityItemToJSON,
    ActivityItemToJSONTyped,
} from './ActivityItem';

/**
 * 
 * @export
 * @interface WidgetDataRecentActivityWidgetData
 */
export interface WidgetDataRecentActivityWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataRecentActivityWidgetData
     */
    $type?: WidgetDataRecentActivityWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<ActivityItem>}
     * @memberof WidgetDataRecentActivityWidgetData
     */
    items: Array<ActivityItem>;
}


/**
 * @export
 */
export const WidgetDataRecentActivityWidgetDataTypeEnum = {
    RecentActivity: 'recent-activity'
} as const;
export type WidgetDataRecentActivityWidgetDataTypeEnum = typeof WidgetDataRecentActivityWidgetDataTypeEnum[keyof typeof WidgetDataRecentActivityWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataRecentActivityWidgetData interface.
 */
export function instanceOfWidgetDataRecentActivityWidgetData(value: object): value is WidgetDataRecentActivityWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WidgetDataRecentActivityWidgetDataFromJSON(json: any): WidgetDataRecentActivityWidgetData {
    return WidgetDataRecentActivityWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataRecentActivityWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataRecentActivityWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(ActivityItemFromJSON)),
    };
}

export function WidgetDataRecentActivityWidgetDataToJSON(json: any): WidgetDataRecentActivityWidgetData {
    return WidgetDataRecentActivityWidgetDataToJSONTyped(json, false);
}

export function WidgetDataRecentActivityWidgetDataToJSONTyped(value?: WidgetDataRecentActivityWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(ActivityItemToJSON)),
    };
}

